import type { Operation } from '@vigilo/shared';

export const DEFAULT_CROWD_OPERATION_ID = '33333333-0000-4000-8000-000000000001';

const LIVE_OPERATION_STATUSES = new Set(['active', 'paused']);

function isLiveOperation(op: Operation): boolean {
  return LIVE_OPERATION_STATUSES.has(op.status);
}

function operationStartMs(op: Operation): number {
  const ms = Date.parse(op.actualStart ?? op.scheduledStart);
  return Number.isFinite(ms) ? ms : Number.MAX_SAFE_INTEGER;
}

export function sortOperationsForSession(ops: Operation[]): Operation[] {
  return [...ops].sort((a, b) => {
    if (a.id === DEFAULT_CROWD_OPERATION_ID && isLiveOperation(a)) return -1;
    if (b.id === DEFAULT_CROWD_OPERATION_ID && isLiveOperation(b)) return 1;
    if (a.status !== b.status) return a.status === 'active' ? -1 : 1;
    return operationStartMs(a) - operationStartMs(b);
  });
}

export function findSeededDefaultOperation(ops: Operation[]): Operation | null {
  return ops.find(op => op.id === DEFAULT_CROWD_OPERATION_ID && isLiveOperation(op)) ?? null;
}

export function chooseDefaultOperation(ops: Operation[]): Operation | null {
  return findSeededDefaultOperation(ops) ?? sortOperationsForSession(ops).find(isLiveOperation) ?? null;
}
